/**
 * 语言配置api
 */
import { createAPI } from '../http'
import axios from "axios";
import { API_SVC_HOST } from '../../config/common';
axios.create({
    baseURL: API_SVC_HOST
});
const api = createAPI();
export function getLangData() {
    /**查询语言的信息 */
    return api.get('/api/language_configuration_excel')
}
export function getLangDetailByKey(key) {
    /**查询语言的信息 通过key*/
    return api.get(`/api/language_configuration/${key}`)
}
export function getLangMenu() {
    /**查询语言 菜单的信息 */
    return api.get(`/api/language_configuration`)
}
export function setLangData(key, params) {
    /**设置 语言的信息 */
    return api.put(`/api/language_configuration/${key}`, params)
}